import IBAN from "iban"
import { filterValidationFields, isEmpty, validateForm } from "../../../services/functions"
import moment from "moment"
import 'moment/locale/sq'  
import { showIbanValidation } from "../OpenBankingUtils"



export const description = `Pagese paga ${moment().locale("sq").format("MMMM YYYY")}`

export const defaultPayroll={
    transferType:"ONEBYONE",
    templateType:"IBAN",
    period:moment().format("MM/YYYY"),
    issueDateTime: new Date(),
    requestedExecutionDate: new Date(),
    companyBankAccount:null,
    description,
    salaryRecords:[
      {
        iban: null,
        description,
        amount:null,
        currency: "ALL",
        employeeFullName: null,
        connectionAccount: null,
        bankReferenceNumber: null,
        bankStatus: null,
        bankPaymentDate: null

      }
    ]
}

export const mapSalrayEmployee=(accountEmploye,defaultSalaryRecord={})=>{
  const { value,label,contact:connectionAccount,...account} = accountEmploye
  const { name:employeeFullName }=connectionAccount

  return {
    ...defaultSalaryRecord,
    iban:account.iban,
    currency:account.currency,
    employeeFullName,
    connectionAccount:account
  }
}

export const isPayrollValid = ({validateOnlyEmployeesFields=false,t,setValidationErrors,payroll,excludeFields}={}) => {
    let validateFields=[
      {
        value: "salaryRecords",
        label: "Salary Records",
        optional:true,
        fields: [
          { value:"employeeFullName",label:"Employee Full Name"},
          { value: "amount", label: "Amount" },
          { value: "iban", label: "Iban", message: "Iban is not valid", validation: (iban) => showIbanValidation?IBAN.isValid(iban):   !isEmpty(iban) },
          
        ]
      }
    ]

    if(!validateOnlyEmployeesFields){
      validateFields= validateFields.concat([
          { value:"templateType",label:"Template Type" },
          { value:"transferType",label:"Transfer Type" },
          { value:"period",label:"Period" },
          { value:"companyBankAccount",label:"Company Bank Account" },
        ])
    }



    validateFields = filterValidationFields(validateFields, excludeFields);
    const validationObj=validateForm(validateFields,payroll) 

    if (payroll.salaryRecords && payroll.salaryRecords.length > 0) {
      const ibans = payroll.salaryRecords.map(salaryRecord => salaryRecord.iban).filter(Boolean);
      const duplicateIbans = ibans.filter((iban, index) => ibans.indexOf(iban) !== index);
      if (duplicateIbans.length > 0) {
        payroll.salaryRecords.forEach((salary, index) => {
          if (duplicateIbans.includes(salary.iban)) {
            validationObj.errors[`salaryRecords.${index}.iban`] = {
              message: t("mySuppliers.duplicteIbanNotAllowed"),
              isCustom: true
            };
          }
        });
      }
    }

  if (!validationObj.isValid || Object.keys(validationObj.errors).length > 0) {
    setValidationErrors(validationObj.errors);
    return false;
  }
    return true
};
